var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7474 3.13509L13.3786 7.50395C13.137 7.74555 12.7363 7.74555 12.4947 7.50395C12.2531 7.26236 12.2531 6.86166 12.4947 6.62007L16.8635 2.2512C17.1051 2.00961 17.5058 2.00961 17.7474 2.2512C17.989 2.4928 17.989 2.89349 17.7474 3.13509Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3368 6.91481C18.2248 7.02677 18.0716 7.09748 17.8948 7.09748C17.5531 7.09748 17.2702 6.81464 17.2702 6.47287L17.2702 2.72861L13.526 2.72861C13.1842 2.72861 12.9013 2.44577 12.9013 2.104C12.9013 1.76224 13.1842 1.47939 13.526 1.47939L17.8948 1.47939C18.2366 1.47939 18.5194 1.76223 18.5194 2.104L18.5194 6.47287C18.5194 6.64965 18.4487 6.80285 18.3368 6.91481Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76673 16.3493L7.1356 11.9804C7.3772 11.7388 7.77789 11.7388 8.01948 11.9804C8.26108 12.222 8.26108 12.6227 8.01948 12.8643L3.65062 17.2332C3.40902 17.4748 3.00833 17.4748 2.76673 17.2332C2.52514 16.9916 2.52514 16.5909 2.76673 16.3493Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1774 12.57C2.28935 12.4581 2.44256 12.3874 2.61934 12.3874C2.96111 12.3874 3.24395 12.6702 3.24395 13.012L3.24395 16.7562L6.9882 16.7562C7.32997 16.7562 7.61281 17.0391 7.61281 17.3809C7.61281 17.7226 7.32997 18.0055 6.9882 18.0055L2.61934 18.0055C2.27757 18.0055 1.99473 17.7226 1.99473 17.3809L1.99473 13.012C1.99473 12.8352 2.06544 12.682 2.1774 12.57Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand_icon.f110cc10cfed10bcbee7804a789ee666.svg";
export { ForwardRef as ReactComponent };